module.exports = __webpack_public_path__ + "levy_square-83689cd2a691a75136dd13c61813c323.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/media-images/dk/levy_square.jpg
// module id = 1164
// module chunks = 1 2